import React from 'react'
import * as R from 'ramda'

import { FeatureFlag } from 'components/auth/FeatureFlag'
import { Sidebar } from 'components/layouts/Sidebar/Sidebar'

import { DEFAULT_JOBS_QUERY_PARAMS } from 'constants/projects'
import { toProjects } from 'ducks/router'
import { getLinkActions, getNavigationLinks } from './model'

export const DashboardSidebar = ({ onToggle, isToggled }) => {
  const links = getNavigationLinks()

  return (
    <Sidebar isCollapsed={!isToggled}>
      <Sidebar.Logo
        redirectTo={toProjects(null, null, DEFAULT_JOBS_QUERY_PARAMS)}
        isCollapsed={!isToggled}
      />
      <Sidebar.ToggleButton {...{ onToggle }} />
      <Sidebar.Navigation>
        {R.map(({ featureFlag, icon, label, type, isActive, isExact }) => {
          const to = getLinkActions(type)

          return (
            <FeatureFlag
              key={label}
              {...(Boolean(featureFlag) && { [featureFlag]: true })}
            >
              <Sidebar.NavigationItem
                isCollapsed={!isToggled}
                {...{ icon, label, to, isActive, isExact }}
              />
            </FeatureFlag>
          )
        }, links)}
      </Sidebar.Navigation>
    </Sidebar>
  )
}
